// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FolderResponseShape from '../contract/FolderResponseShape';

export default function folderResponseShape(data: FolderResponseShape): FolderResponseShape {
    const result: FolderResponseShape = {
        __type: 'FolderResponseShape:#Exchange',
        ...data,
    };

    return result;
}
